module.exports = __webpack_public_path__ + "fonts/Roboto-100-greek-ext11.1a51e9e.woff2";